import _sortBy from 'lodash/sortBy';
import { copyUploadcareFileToZola } from 'components/common/UploadcareWidget/utils';
import { getAlbumPhotos, getAlbumCategories, assignPhotosToAlbum } from 'photobooks/utils/api';
import { getGalleryPhotos } from './selectors';

export const clearGallery = () => ({
  type: 'CLEAR_GALLERY',
});

export const setPhotos = payload => ({
  type: 'SET_PHOTOS',
  payload,
});

export const setCategories = payload => ({
  type: 'SET_CATEGORIES',
  payload,
});

export const resetGallery = () => ({ type: 'RESET_GALLERY_STATE' });

export const setGalleryDragState = payload => ({
  type: 'SET_GALLERY_DRAG_STATE',
  payload,
});

export const setPhotoMenuDragState = payload => ({
  type: 'SET_PHOTOMENU_DRAG_STATE',
  payload,
});

export const assignPhotos = ({ albumUuid, images }) => {
  return (dispatch, getState) => {
    const allPhotos = getGalleryPhotos(getState());

    // Images are already ordered by position.
    const offset = allPhotos.length === 0 ? 1 : allPhotos[allPhotos.length - 1].position + 1;

    return Promise.all(images.map(image => copyUploadcareFileToZola(image))).then(storedImages => {
      return assignPhotosToAlbum({ albumUuid, images: storedImages, offset })
        .then(() => getAlbumPhotos({ albumUuid }))
        .then(data => dispatch(setPhotos(data)));
    });
  };
};

export const simpleAssignPhotos = ({ albumUuid, uploadedImages }) => {
  return (dispatch, getState) => {
    const allPhotos = getGalleryPhotos(getState());

    // Images are already ordered by position.
    const offset = allPhotos.length === 0 ? 1 : allPhotos[allPhotos.length - 1].position + 1;

    return assignPhotosToAlbum({ albumUuid, images: uploadedImages, offset })
      .then(() => getAlbumPhotos({ albumUuid }))
      .then(data => dispatch(setPhotos(data)))
      .catch(() => {});
  };
};

export const fetchAllPhotos = payload => dispatch => {
  return getAlbumPhotos(payload).then(data => {
    const photos = _sortBy(data, d => d.position);

    dispatch(setPhotos(photos));

    return photos;
  });
};

export const fetchPhotos = payload => {
  return dispatch => {
    return getAlbumPhotos(payload).then(data => {
      const photos = _sortBy(data, d => d.position);

      dispatch(setPhotos(photos));

      return photos;
    });
  };
};

export const fetchCategories = payload => {
  return dispatch => {
    return getAlbumCategories(payload).then(data => {
      const categories = _sortBy(data, d => d.position);

      dispatch(setCategories(categories));
      return categories;
    });
  };
};

export const assignPhotosToCategory = ({ albumUuid, images, mediaCategoryUuid }) => {
  return (dispatch, getState) => {
    const allPhotos = getGalleryPhotos(getState());

    // Images are already ordered by position.
    const offset = allPhotos.length === 0 ? 1 : allPhotos[allPhotos.length - 1].position + 1;

    return Promise.all(images.map(image => copyUploadcareFileToZola(image))).then(storedImages => {
      return assignPhotosToAlbum({
        albumUuid,
        images: storedImages,
        offset,
        mediaCategoryUuid,
      })
        .then(() => getAlbumPhotos({ albumUuid }))
        .then(data => dispatch(setPhotos(data)));
    });
  };
};

export const assignPhotosToCategoryLite = ({ albumUuid, images, mediaCategoryUuid }) => {
  return (dispatch, getState) => {
    const allPhotos = getGalleryPhotos(getState());
    // Images are already ordered by position.
    const offset = allPhotos.length === 0 ? 1 : allPhotos[allPhotos.length - 1].position + 1;

    return assignPhotosToAlbum({
      albumUuid,
      images,
      offset,
      mediaCategoryUuid,
    })
      .then(() => getAlbumPhotos({ albumUuid }))
      .then(data => dispatch(setPhotos(data)));
  };
};



// WEBPACK FOOTER //
// ./src/photobooks/reducers/gallery/actions.js